import Joi from '@hapi/joi'

export const factoryItemsSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({ "any.invalid": `Group Required`, }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({ "any.invalid": `Operation Entity Required`, }),
    //productID: Joi.number().invalid(0).required().label("Product Name").messages({ "any.invalid": `Product Required`, }),
    factoryItemCode: Joi.string().required().label("Item Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Item Code required`,
        "string.pattern.base": `Please enter valid Item Code`,
    }),
    
    

    factoryItemName: Joi.string().required().label("Item Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Item Name required`,
        "string.pattern.base": `Please enter valid Item Name`,
    }),

    itemCategoryID: Joi.number().invalid(0).required().label("Item Category ID").messages({"any.invalid": `Item Category ID required`}),

    measuringUnit: Joi.number().invalid(0).required().label("Measuring Unit").messages({"any.invalid": `Measuring Unit Required`}),

    factoryItemDescription: Joi.string().required().label("Description").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Item Description required`,
        "string.pattern.base": `Please enter valid Item Description`,
    }),
    /*price: Joi.number().invalid(0).required().label("Price").messages({
        "any.invalid": `Price Required`, 
    }),*/
    isActive: Joi.boolean().label("Active"),
}